import { render, staticRenderFns } from "./indexCost.vue?vue&type=template&id=57b2a345&scoped=true"
import script from "./indexCost.vue?vue&type=script&lang=js"
export * from "./indexCost.vue?vue&type=script&lang=js"
import style0 from "./indexCost.vue?vue&type=style&index=0&id=57b2a345&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b2a345",
  null
  
)

export default component.exports